// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"815":"91cd900c","906":"563e0e72"}[chunkId] + ".chunk.css";
};